import { Slice as ProgressSpinnerSlice } from "./redux/Slice";
import { ProgressSpinner } from "./ProgressSpinner";

export { ProgressSpinner, ProgressSpinnerSlice };
